export default __webpack_public_path__ + "static/media/janko-ferlic-sfL_QOnmy00-unsplash.8434c007.jpg";